module.exports = __webpack_public_path__ + "static/media/zoom-icon.817459b9.svg";